module.exports = __webpack_public_path__ + "media/assets/community/fb-logo-0d2e2f617f73df1b1ad4e22e12404169d12ecc644385440b80175605780a69d8.png";